import { config as developmentConfig } from "./environments/development";
import { config as productionConfig } from "./environments/production";
import { config as stagingConfig } from "./environments/staging";
import { config as testConfig } from "./environments/test";

export type AppConfig = {
  /** API サーバーの URL（NEXT_PUBLIC_API_URL として注入される） */
  apiUrl: string;
  /** GTM コンテナ ID（null の場合は GTM を読み込まない） */
  gtmContainerId: string | null;
  /** Stripe 発行のプランコード（環境ごとに異なる） */
  planCodes: {
    free: string;
    beginner: string;
    enterprise: string;
  };
  /** デモ用 PlanGate バイパス（true で全機能解放。詳細は docs/infrastructure/demo-mode.md） */
  bypassPlanGate: boolean;
};

const configs: Record<string, AppConfig> = {
  development: developmentConfig,
  staging: stagingConfig,
  production: productionConfig,
  test: testConfig,
};

function validateConfig(config: AppConfig, env: string): void {
  const required: (keyof AppConfig)[] = ["apiUrl", "planCodes"];
  const missing = required.filter((key) => !config[key]);
  if (missing.length > 0) {
    throw new Error(`[app.config] 設定値が未設定です (env=${env}): ${missing.join(", ")}`);
  }
}

export function getConfig(): AppConfig {
  // ビルド時（next.config.ts）は APP_ENV のみ参照可能（NEXT_PUBLIC_APP_ENV は next.config.ts 自身が設定する）
  // クライアントサイド（ブラウザ）は NEXT_PUBLIC_APP_ENV のみ参照可能（APP_ENV は NEXT_PUBLIC_ なし）
  const env = process.env["NEXT_PUBLIC_APP_ENV"] || process.env["APP_ENV"] || "development";
  const config = configs[env] ?? developmentConfig;
  validateConfig(config, env);
  return config;
}
